import * as TYPES from "../types";

export const games = (state = [], action) => {
  switch (action.type) {
    case TYPES.REPLACE_GAMES:
      return [...action.games];
    case TYPES.REPLACE_GAMES_SCORE:
      return state;
    default:
      return state;
  }
};

export const playsIgnored = (state = {} , action) => {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case TYPES.SET_IGNORE_PLAYS:
      newState[action.gameId]= action.plays;
      return newState;
    default:
      return state;
  }
};